export default "__VITE_ASSET__DlXNiGtW__"